import React from 'react'
import { Line } from 'react-chartjs-2'

import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import { getProcessSelectList, getStateSelectList } from '../../state/helper'
import LabelInput from '../../../form/component/LabelInput'
import { renderStateName } from '../../../process/util/names'
import { MODE_LIST } from '../../state/transition/const'
import { COMPANY_CODE_SELECT_VALUE_LIST } from '../../../internationalization/const'

const COLOR_LIST = [
    '0,145,231',
    '255,193,44',
    '255,138,0',
    '255,63,107',
    '18,178,178',
    '133,70,255',
    '186,188,193',
]


const compileGraphData = (transitionList, mode) => {
    let max = 0
    let maxIndex = 0
    for (let index = 0; index < transitionList.length; index++) {
        const item = transitionList[index]
        const transitionCount = item.transition.length
        if (transitionCount > max) {
            max = transitionCount
            maxIndex = index
        }
    }

    const result = {
        labels: transitionList[maxIndex].transition.map(item => {
            return item.offset
        }),
        datasets: [],
    }
    for (let index = 0; index < transitionList.length; index++) {
        const color = COLOR_LIST[index % 7]


        const item = transitionList[index]

        result.datasets.push({
            label: ' Week ' + item.week,
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(' + color + ',0.4)',
            borderColor: 'rgba(' + color + ',1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(' + color + ',1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(' + color + ',1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: item.transition.map(transition => {
                return Math.round(transition[mode])
            }),
        })
    }
    return result
}


const weekList = []
for (let week = 1; week < 54; week++) {
    weekList.push({
        id: '' + week,
        value: '' + week,
    })
}


const yearList = []
const today = new Date()
const currentYear = today.getFullYear()
for (let year = 2018; year <= currentYear; year++) {
    yearList.push({
        id: '' + year,
        value: '' + year,
    })
}


const Transition = ({ processState, changeProcessState, processStateNameList, yearWeekList, changeYearWeek, deleteYearWeek, transitionList, mode }) => {
    const processNameSelectList = getProcessSelectList(processStateNameList)
    const startStateList = getStateSelectList(processStateNameList, processState.startProcessName)
    const endStateList = getStateSelectList(processStateNameList, processState.endProcessName)
    return (
        <div>
            <ContentBox title="State Transition">
                <Row>
                    <Column size={2}>
                        <LabelInput label="Start Process">
                            <Select object={processState}
                                name="startProcessName"
                                addEmpty={!processState.startProcessName}
                                valueList={processNameSelectList}
                                onChange={changeProcessState}/>
                        </LabelInput>
                        <LabelInput label="Start State">
                            <Select object={processState}
                                name="startStatus"
                                addEmpty={!processState.startStatus}
                                valueList={startStateList}
                                renderer={(stateName) => {
                                    return renderStateName(stateName.value)
                                }}
                                onChange={changeProcessState}/>
                        </LabelInput>
                        <LabelInput label="Mode">
                            <Select object={processState}
                                name="mode"
                                addEmpty={false}
                                valueList={MODE_LIST}
                                onChange={changeProcessState}/>
                        </LabelInput>
                    </Column>
                    <Column size={2}>
                        <LabelInput label="Target Process">
                            <Select object={processState}
                                name="endProcessName"
                                addEmpty={!processState.endProcessName}
                                valueList={processNameSelectList}
                                onChange={changeProcessState}/>
                        </LabelInput>
                        <LabelInput label="Target State">
                            <Select object={processState}
                                name="endStatus"
                                addEmpty={!processState.endStatus}
                                valueList={endStateList}
                                renderer={(stateName) => {
                                    return renderStateName(stateName.value)
                                }}
                                onChange={changeProcessState}/>
                        </LabelInput>
                    </Column>
                    <Column size={3}>
                        {yearWeekList.map((yearWeek, index) => {
                            return (<YearWeekRow key={index} changeYearWeek={changeYearWeek} yearWeek={yearWeek} index={index} deleteYearWeek={deleteYearWeek}/>)
                        })}
                        <YearWeekRow changeYearWeek={changeYearWeek} yearWeek={{ year: currentYear }} index={yearWeekList.length}/>
                    </Column>
                    <Column size={3}>
                        <LabelInput label="Company">
                            <Select object={processState} name="companyCode" valueList={COMPANY_CODE_SELECT_VALUE_LIST}
                                onChange={changeProcessState}/>
                        </LabelInput>
                    </Column>
                    <Column size={2}/>
                </Row>
            </ContentBox>
            {transitionList && (
                <ContentBox>
                    <Line data={compileGraphData(transitionList, mode)}/>
                </ContentBox>
            )}
        </div>)
}

const YearWeekRow = ({ changeYearWeek, yearWeek, index, deleteYearWeek }) => {
    return (
        <div>
            <div className="transition-builder-cw-year-week">
                <LabelInput label="Year">
                    <Select
                        object={yearWeek}
                        name="year"
                        addEmpty={!yearWeek.year}
                        valueList={yearList}
                        onChange={(name, value) => {
                            changeYearWeek(index, name, value)
                        }}/>
                </LabelInput>
            </div>
            <div className="transition-builder-cw-year-week">
                <LabelInput label="Week">
                    <Select
                        object={yearWeek}
                        name="week"
                        addEmpty={!yearWeek.week}
                        valueList={weekList}
                        onChange={(name, value) => {
                            changeYearWeek(index, name, value)
                        }}/>
                </LabelInput>
            </div>
            <div className="transition-builder-cw-year-delete">
                {deleteYearWeek && (<i className="fa fa-minus-circle transition-builder-delete-cw" onClick={() => {
                    deleteYearWeek(index)
                }}/>)}
            </div>
        </div>
    )
}


export default lifecycle({
    componentDidMount () {
    },
})(withLayout(Transition))





// WEBPACK FOOTER //
// ./src/modules/analytics/component/transition/Transition.js